export type PmsProvider = 'entrata' | 'realPage' | 'rentManager' | 'resman' | 'yardi'

export type PmsLookupProvider = 'entrata' | 'rentManager' | 'yardi'

export const PMS_CONNECTABLE_PROVIDERS = [
  'yardi',
  'entrata',
  'realPage',
  'rentManager',
] as const satisfies readonly PmsProvider[]

export const PMS_ROUTE: Record<PmsProvider, string> = {
  entrata: 'entrata',
  realPage: 'real-page',
  rentManager: 'rent-manager',
  resman: 'resman',
  yardi: 'yardi',
}

export const isPmsLookupProvider = (provider: PmsProvider | null | undefined) =>
  provider === 'yardi' || provider === 'entrata' || provider === 'rentManager'
